import { Injectable, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';

import { VersionGateDialogComponent } from './version-gate-dialog.component';
import { VersionGateKind, VersionPolicyService } from './version-policy.service';

@Injectable({ providedIn: 'root' })
export class VersionGateDialogService implements OnDestroy {
  private dialogRef?: MatDialogRef<VersionGateDialogComponent>;
  private stateSubscription?: Subscription;

  constructor(
    private dialog: MatDialog,
    private versionPolicyService: VersionPolicyService,
  ) {}

  initialize(): void {
    if (this.stateSubscription) {
      return;
    }
    this.stateSubscription = this.versionPolicyService.state.subscribe(state => {
      this.reconcile(state.kind);
    });
  }

  ngOnDestroy(): void {
    this.stateSubscription?.unsubscribe();
    this.dialogRef?.close();
  }

  private reconcile(kind: VersionGateKind): void {
    if (kind !== 'required' || this.dialogRef) {
      return;
    }

    const config: MatDialogConfig = {
      ariaLabelledBy: 'version-gate-title',
      autoFocus: true,
      backdropClass: 'version-gate-dialog-backdrop',
      closeOnNavigation: false,
      disableClose: true,
      maxWidth: '420px',
      panelClass: 'version-gate-dialog-panel',
      restoreFocus: true,
      role: 'dialog',
      width: 'calc(100vw - 48px)',
    };
    config.ariaModal = true;
    this.dialogRef = this.dialog.open(VersionGateDialogComponent, config);
  }
}
